import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { withRouterProps } from '../../../utils/with-router-props'

import { callApi } from '../../../../actions/api'
import { apiResourceEndpoint, buildRoutePath, routes } from '../../../../constants/routes'


const AdminChefSettings = ({ dispatch, chef, navigate }) => {
    const handleDelete = () => {
        let deleteMe = window.confirm('Are you sure you want to delete this chef? This action cannot be undone.')
        if (deleteMe) {
            dispatch(callApi(apiResourceEndpoint('admin/chefs', 'DELETE', chef.id), {}, -1))
                .then(() => {
                    navigate(routes.adminChefsIndex.path)
                })
        }
    }

    return (
        <>
            <h2>Chef Settings</h2>
            <div className="box">
                <p>
                    <button className="btn" onClick={handleDelete}>
                    Delete {chef.displayName}
                    </button>
                </p>
                <h3>Or</h3>
                <p>
                    <Link to={buildRoutePath(routes.adminChefProfileIndex.path, { chefId: chef.id })}>
                    Back to Profile
                    </Link>
                </p>
            </div>
        </>
    )
}

export default withRouterProps(connect()(AdminChefSettings))
